import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20illustration%20of%20a%20vibrant%20manga%20and%20manhwa%20reading%20scene%20with%20floating%20comic%20pages%20and%20colorful%20abstract%20brush%20strokes%2C%20warm%20coral%20and%20golden%20accents%20on%20a%20dark%20background%2C%20dynamic%20composition%2C%20modern%20illustration%20style%2C%20artistic%20and%20dreamy%20atmosphere&width=1600&height=900&seq=hero-bg-comics-01&orientation=landscape"
          alt="尾巴漫画 - 免费韩国漫画在线阅读平台"
          className="w-full h-full object-cover object-top"
          width={1600}
          height={900}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 max-w-3xl leading-tight">
          免费韩国漫画在线阅读
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          海量最新高清韩漫，支持便捷下拉式观看，每日更新，带来极致流畅的阅读体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/hot"
            className="bg-primary-500 hover:bg-primary-600 text-white font-medium px-8 py-3 rounded-full text-base whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            热门推荐
          </Link>
          <Link
            to="/category/latest"
            className="bg-white/15 hover:bg-white/25 text-white font-medium px-8 py-3 rounded-full text-base whitespace-nowrap cursor-pointer backdrop-blur-sm transition-colors duration-200"
          >
            最新上架
          </Link>
        </div>

        <div className="flex items-center gap-6 md:gap-10 mt-10 md:mt-14">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">2000+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">精品韩漫</div>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">追更不停</div>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">忠实读者</div>
          </div>
        </div>
      </div>
    </section>
  );
}